export function openBase64(base64: string, filename: string) {
	const newWindow = window.open('', '_blank');
	if (newWindow) {
		const extension = filename.split('.').pop()?.toLowerCase();
		const mimeTypes: {[key: string]: string} = {
			doc: 'application/msword',
			docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			xls: 'application/vnd.ms-excel',
			xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			pdf: 'application/pdf',
			jpeg: 'image/jpeg',
			jpg: 'image/jpeg',
			png: 'image/png',
		};

		const mimeType = mimeTypes[extension || ''];

		if (mimeType) {
			const byteCharacters = atob(base64.split(',')[1]);
			const byteNumbers = new Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i += 1) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			const blob = new Blob([byteArray], {type: mimeType});
			const url = URL.createObjectURL(blob);

			if (extension === 'jpeg' || extension === 'jpg' || extension === 'png') {
				newWindow.document.write(`<title>${filename}</title>`);
				newWindow.document.write(`<img src="${url}" />`);
			} else {
				newWindow.location.href = url;
			}
		} else {
			// eslint-disable-next-line no-console
			console.error('Tipo de arquivo não suportado:', extension);
		}
	}
}
